import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

export class TableCell extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    colSpan: PropTypes.string,
    style: PropTypes.object,
    head: PropTypes.bool,
    dataTestId: PropTypes.string,
  };

  renderHeadCell() {
    const { children, className, dataTestId, head, style } = this.props;
    const cellClass = classNames(
      "TableCell",
      { "TableCell--head": head },
      className
    );
    return (
      <th className={cellClass} data-testid={dataTestId} style={{ ...style }}>
        {children}
      </th>
    );
  }

  renderCell() {
    const { children, className, colSpan, dataTestId, style } = this.props;
    const cellClass = classNames("TableCell", className);

    return (
      <td
        className={cellClass}
        colSpan={colSpan}
        data-testid={dataTestId}
        style={{ ...style }}
      >
        {children}
      </td>
    );
  }

  render() {
    const { head } = this.props;
    return head ? this.renderHeadCell() : this.renderCell();
  }
}

export default TableCell;
